import React from 'react';

const FirebaseContext = React.createContext(null);
const AuthContext = React.createContext(null);

export {
  FirebaseContext,
  AuthContext,
};